module.exports = __webpack_public_path__ + "static/media/headshot-np.8bf59b35.jpg";